/** @format */

import { Component, OnDestroy, OnInit, ViewChild, input } from '@angular/core';
import {
	InvalidResponse,
	ProductReviewAnalyticsService,
	Review,
	ReviewMedia,
	ReviewSelectedMedia,
	UtilityReviewService,
	addSliderState,
	selectProductReviewImageModal,
	selectProductReviewsMultimedia
} from '@product-reviews/data-access';
import { Observable, Subject } from 'rxjs';

import { MediaSourceEnum } from '../models';
import { Store as NgRxStore } from '@ngrx/store';
import { ReviewModalComponent } from '../review-modal/review-modal.component';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'product-reviews-carousel-component',
    templateUrl: './review-carousel.component.html',
    styleUrls: ['./review-carousel.component.scss'],
    standalone: false
})
export class ReviewhighlightCarouselComponent implements OnInit, OnDestroy {
	/**
	 *
	 * @description
	 * Product Id - Bizaar voice uses this identifier to display the correct reviews
	 */
	productIdentifier = input<string>();

	/**
	 *
	 * @description
	 * hasNewReviewsEnhancement - allows us to select the content according to the flag to be able to test
	 */
	hasNewReviewsEnhancement = input(false);

	/**
	 *
	 * @description
	 * Review - Receive the review to show the images or videos
	 */
	review = input<Review>();

	/**
	 *
	 * @description
	 * selector - Receive the nane of the carousel selector.
	 */
	selector = input('scrollable-list');
	mediaSource = input(MediaSourceEnum.CAROUSEL);

	/**
	 *
	 * @description
	 * hideTitle - Determines if the Images title should be hidden
	 */
	hideTitle = input(false);

	/**
	 *
	 * @description
	 * analyticsMediaClickValue - Determines if an analytic event should be sent when an image is clicked
	 */
	analyticsMediaClickValue = input('Highlights Image Expanded');

	/**
	 *
	 * @description
	 * listenOpeningModal - Checks if component should listen to the open modal event (should only be for review highlights section)
	 */
	listenOpeningModal = input(false);

	reviews: Review[] = [];
	reviewSelected: Review;
	medias: ReviewMedia[] = [];

	selectReviewsMultimedia: Observable<Review[] | InvalidResponse> = this.store.select(
		selectProductReviewsMultimedia
	);
	selectProductReviewImageModal: Observable<boolean> = this.store.select(selectProductReviewImageModal);
	private UNSUBSCRIBE$ = new Subject<void>();
	@ViewChild(ReviewModalComponent) reviewModalComponent: ReviewModalComponent | undefined;

	constructor(
		private store: NgRxStore,
		private utilityReviewService: UtilityReviewService,
		private analyticsService: ProductReviewAnalyticsService
	) {}

	ngOnInit(): void {
		this.selectReviewsMultimedia
			.pipe(takeUntil(this.UNSUBSCRIBE$))
			.subscribe((reviewsMultimedia) => {
				if (reviewsMultimedia instanceof InvalidResponse) {
					return;
				}
				this.reviews = [...reviewsMultimedia];
				this.medias = this.utilityReviewService.transformReviewMedia(this.reviews);
			});

		if (this.listenOpeningModal()) {
			this.selectProductReviewImageModal
			.pipe(takeUntil(this.UNSUBSCRIBE$))
			.subscribe((openState) => {
				if (openState) {
					this.handleReview({
						...this.medias[0],
						imageId: 0
					});
				}
			});
		}
	}

	ngOnDestroy() {
		this.UNSUBSCRIBE$.next();
		this.UNSUBSCRIBE$.complete();
	}

	/**
	 * Execute analytics services
	 */
	handleReview(reviewMedia: ReviewSelectedMedia) {
		this.analyticsService.fireReviewAnalytics<{ event: string; value: string }>({
			name: 'multiUseAnalyticsEvent',
			payload: { event: 'RatingsAndReviewsInteractions', value: this.analyticsMediaClickValue() }
		});

		// eslint-disable-next-line no-unused-expressions
		this.reviewModalComponent && this.reviewModalComponent.openModal();
		this.reviewSelected = this.reviews.find((review) => review.Id == reviewMedia.reviewId);
		const imageIndex = this.medias.findIndex(({ id }) => id === reviewMedia.id);

		this.store.dispatch(
			addSliderState({
				slider: {
					media: reviewMedia,
					review: this.reviewSelected,
					position: {
						previous: imageIndex - 1 > 0 ? imageIndex - 1 : null,
						current: imageIndex,
						next:
							this.medias.length > imageIndex + 1
								? imageIndex + 1
								: this.medias.length
					}
				}
			})
		);
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	trackByFn(index: number, _item: any): number {
		return index;
	}
}
